import classNames from 'classnames';
import { LabelBodyHeadline, ToolbarItem } from '../features/modules/components';
import { ChevronLeftIcon } from '../features/modules/icons';

type Props = {
    children: React.ReactNode;
    className?: string;
    onBack?: () => void;
    rightToolbarItem?: {
        icon: React.ReactNode;
        action: () => void;
    };
    title: string;
    singleLineTitle?: boolean;
    bottomPadding?: boolean;
};
/// This is the root view for establishing proper OS-level padding (safe-area) and full-screen height.
export function AppLikeRootView({
    children,
    className,
    onBack,
    rightToolbarItem,
    title,
    singleLineTitle = false,
    bottomPadding = true,
}: Props) {
    return (
        <div
            className={classNames(className, 'flex grow flex-col')}
            style={{
                ...(bottomPadding && {
                    paddingBottom: 'max(20px, env(safe-area-inset-bottom))',
                }),

                paddingLeft: 'env(safe-area-inset-left)',
                paddingRight: 'env(safe-area-inset-right)',
            }}
        >
            <header
                className="sticky top-0 z-1 bg-white"
                style={{ paddingTop: 'env(safe-area-inset-top)' }}
            >
                <div className="container-in-app flex items-center">
                    <ToolbarItem onClick={onBack}>
                        {onBack && <ChevronLeftIcon />}
                    </ToolbarItem>
                    <LabelBodyHeadline
                        className={classNames('flex-1 text-center', {
                            'overflow-hidden text-ellipsis whitespace-nowrap':
                                singleLineTitle,
                        })}
                        color="text-dark-red"
                    >
                        {title}
                    </LabelBodyHeadline>
                    <ToolbarItem onClick={rightToolbarItem?.action}>
                        {rightToolbarItem?.icon}
                    </ToolbarItem>
                </div>
            </header>
            <div className="flex grow flex-col">{children}</div>
        </div>
    );
}
